import breakpoints from "../../constants/breakpoints";
import events from "../../constants/events";
import {dispatchEvent} from "../../utilities/customEvents";
import {debounce} from "../../utilities/functions";
import {Base} from "./Base";
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

import Flicking, {EVENTS} from "@egjs/flicking";
import {Pagination} from "@egjs/flicking-plugins";

const classes = {
  hidden: "hidden",
  open: "open",
  searchOpen: "search-open",
  metaHeader: "meta-header",
  fixed: "fixed",
  active: "active",
};

const selectors = {
  collectionImage: ".header__collection-image",
  searchFormBanner: ".header__search-form--banner",
};

const body = document.body;

export class Header extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.itemsHover = [];
    this.timer = null;
    this.logosTimer = null;
    this.membersLogosTimer = null;
    this.logo = "woman";
    this.membersLogo = "mosmosh";
    this.searchInput = null;
    this.searchChangeHandler = null;
    this.init();
    this.renderHeaderHighlightMarks();
  }

  init() {
    this.handleBannerSearchTriggerClick();
    this.handleMenuButtonClick();

    const { menLinklistItems } = this.refs;
    const { womenLinklistItems } = this.refs;
    this.itemsHover = [];
    this.handleItemsHover(menLinklistItems);
    this.handleItemsHover(womenLinklistItems);

    this.startLogos();
    this.startMembersLogos();
    this.handleDropdownHover();
    this.handleCollectionLinkHover();
    this.bindWindowResizeHandler();
    this.bindBodyStyleListener();
    this.forceDownloadCollectionImages();
    this.handleChangeCurrency();

    const { mobileMenList } = this.refs;
    const { mobileWomenList } = this.refs;
    const { mobileMenListItems } = this.refs;
    const { mobileWomenListItems } = this.refs;

    this.searchInput = document.getElementById("search-input");

    this.scrollHandler = this.scrolling.bind(this);
    this.scrolling();
    window.addEventListener("scroll", this.scrollHandler);

    this.handleMobileNavigation(mobileWomenList, mobileWomenListItems, "women");
    this.handleMobileNavigation(mobileMenList, mobileMenListItems, "men");
  }

  scrolling(event) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const shopHeader = document.querySelector('.shop-header');
    if(shopHeader.classList.contains('fixed')){
      body.style.setProperty('--scroll-top-offset', '0px');
    } else {
      body.style.setProperty('--scroll-top-offset', scrollTop+'px');
    }

  }

  startLogos() {
    const logos = document.getElementById("splitscreenLogos");
    if (logos) {
      this.logosTimer = setInterval(() => {
        if (this.logo == "woman") {
          this.logo = "man";
          logos.classList.remove("woman");
          logos.classList.add("man");
          return;
        }
        if (this.logo == "man") {
          this.logo = "heyanno";
          logos.classList.remove("man");
          logos.classList.add("heyanno");
          return;
        }
        if (this.logo == "heyanno") {
          this.logo = "woman";
          logos.classList.remove("heyanno");
          logos.classList.add("woman");
          return;
        }
      }, 2000);
    }
  }

  startMembersLogos() {
    const memberLogos = document.getElementById("memberLogos");
    if (memberLogos) {
      this.membersLogosTimer = setInterval(() => {
        if (this.membersLogo == "mosmosh") {
          this.membersLogo = "members";
          memberLogos.classList.remove("mosmosh");
          memberLogos.classList.add("members");
          return;
        }
        if (this.membersLogo == "members") {
          this.membersLogo = "mosmosh";
          memberLogos.classList.remove("members");
          memberLogos.classList.add("mosmosh");
          return;
        }
      }, 2000);
    }
  }

  renderHeaderHighlightMarks() {
    const headerHighlightMarks = document.getElementById(
      "header-highlight-marks-data"
    );
    let marks = null;
    if (headerHighlightMarks) {
      try {
        marks = JSON.parse(headerHighlightMarks.innerHTML);
      } catch (e) {
        // Error in the JSON
      }
    }

    if (marks) {
      const navLinkItem = document.getElementsByClassName("nav_link_item");
      if (navLinkItem) {
        for (let i = 0; i < navLinkItem.length; i++) {
          let item = navLinkItem[i];
          if (item) {
            for (let m = 0; m < marks.length; m++) {
              let mark = marks[m];
              if (
                mark.navigation_item_name == item.innerHTML &&
                item.classList.contains(mark.vendor)
              ) {
                const today = new Date();
                const startDate =
                  mark.start_date && mark.start_date.length == 10
                    ? new Date(mark.start_date)
                    : null;
                const endDate =
                  mark.end_date && mark.end_date.length == 10
                    ? new Date(mark.end_date)
                    : null;

                if (startDate && endDate) {
                  if (
                    today.getTime() > startDate.getTime() &&
                    today.getTime() < endDate.getTime()
                  ) {
                    const markDiv = document.createElement("div");
                    markDiv.classList.add("highlighted-mark");
                    markDiv.innerHTML = "" + mark.mark_text_name;
                    markDiv.style.color = "" + mark.text_color;
                    markDiv.style.backgroundColor =
                      "" + mark.text_background_color;
                    navLinkItem[i].appendChild(markDiv);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  closeSearch() {
    const { bannerSearchInput } = this.refs;

    body.classList.remove("header-" + classes.searchOpen);

    const header = document.getElementById("header");
    const headerTop = document.getElementById("header-top");
    header.classList.remove(classes.searchOpen);
    headerTop.classList.remove(classes.searchOpen);

    bannerSearchInput.value = "";
    window.removeEventListener("click", this.windowClickListener);
    const searchResults = document.getElementById("search-results");
    enableBodyScroll(searchResults);

    if(this.searchInput) {
      this.searchInput.removeEventListener("input",this.searchChangeHandler);
      this.searchChangeHandler = null;
    }

    window.removeEventListener(events.SELECT_PREDICTION_SEARCH, this.selectPredictionSearchHandler);
    window.removeEventListener(events.CLOSE_SEARCH, this.closeSearchHandler);
  }

  searchChange(event){
    if(this.searchInput) {
      dispatchEvent(window, events.UPDATE_SEARCH, {key:  this.searchInput.value});
    }
  }

  openSearch() {
    body.classList.add("header-" + classes.searchOpen);

    const header = document.getElementById("header");
    const headerTop = document.getElementById("header-top");
    header.classList.add(classes.searchOpen);
    headerTop.classList.add(classes.searchOpen);

    if(this.searchInput) {
      this.searchInput.focus();
      this.searchChangeHandler = this.searchChange.bind(this);
      this.searchInput.addEventListener("input",this.searchChangeHandler);
    }

    this.windowClickListener = this.handleWindowClick.bind(this);
    window.addEventListener("click", this.windowClickListener);

    const searchResults = document.getElementById("search-results");
    // Fix for iOS scrolling issues by allowing touch move on scrollable containers
    const scrollableContainers = searchResults.querySelectorAll('.search-results-inner, .search-results-no-results');
    disableBodyScroll(searchResults, {
      allowTouchMove: (el) => {
        // Allow touch move on scrollable containers and their children
        return Array.from(scrollableContainers).some(container => 
          container === el || container.contains(el)
        );
      }
    });

    this.selectPredictionSearchHandler = this.selectPredictionSearch.bind(this);
    window.addEventListener(events.SELECT_PREDICTION_SEARCH, this.selectPredictionSearchHandler);

    this.closeSearchHandler = this.closeSearch.bind(this);
    window.addEventListener(events.CLOSE_SEARCH, this.closeSearchHandler);
    dispatchEvent(window, events.OPEN_SEARCH, {key:  this.searchInput.value});
  }

  selectPredictionSearch(e){
    const { term } = e.detail;
    this.searchInput.value = term;
    dispatchEvent(window, events.UPDATE_SEARCH, {key:  term});
  }

  handleBannerSearchTriggerClick() {
    const { searchTrigger, bannerSearchInput, closeSearchTrigger } = this.refs;

    if(closeSearchTrigger) {
      closeSearchTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatchEvent(window, events.CLOSE_SEARCH, null);
      });
    }

    if (searchTrigger && bannerSearchInput) {
      searchTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this.element.classList.contains(classes.searchOpen)) {
          dispatchEvent(window, events.CLOSE_SEARCH, null);
        } else {
          this.openSearch();
        }
      });
    }
  }

  handleWindowClick(e) {
    const { bannerSearchInput } = this.refs;
    const searchFormBanner = e.target.closest(selectors.searchFormBanner);
  }

  handleMenuButtonClick() {
    const { menuButton } = this.refs;

    if (menuButton) {
      menuButton.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.element.classList.contains(classes.open)) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      });
    }
  }

  handleItemHover(target) {
    if (target) {
      target.addEventListener("mouseenter", (e) => {
        e.preventDefault();

        if (
          !this.element.classList.contains(classes.open) &&
          window.innerWidth >= breakpoints.MD
        ) {
          // Hide hover on all prev targets
          this.closeAllItems();

          // Set hover on current target
          target.classList.add("open");
          const id = target.getAttribute("data-ref-header");
          const collection = document.getElementsByClassName(id + "-dropdown");
          for (let i = 0; i < collection.length; i++) {
            collection[i].classList.add("open");
          }
          //
          this.openDropdown();
        }
      });

      target.addEventListener("mouseleave", (e) => {
        e.preventDefault();

        target.style = "outline:none;";

        if (
          this.element.classList.contains(classes.open) &&
          window.innerWidth >= breakpoints.MD
        ) {
          this.closeTimeout = setTimeout(() => {
            this.closeDropdown();
          }, 50);
        }
      });
    }
  }

  camelize(str) {
    let arr = str.split("-");
    let capital = arr.map((item, index) =>
      index
        ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
        : item.toLowerCase()
    );
    return capital.join("");
  }

  handleItemsHover(linklistItems) {
    if (linklistItems) {
      var children = linklistItems.childNodes;
      var list = Array.prototype.slice.call(children);
      for (let i = 0; i < list.length; i++) {
        const child = list[i];
        if (
          child &&
          child.classList &&
          child.classList.contains("header__has-children")
        ) {
          const target =
            this.refs[this.camelize(child.getAttribute("data-ref-header"))];

          this.itemsHover.push(target);
          this.handleItemHover(target);
        }
      }
    }
  }

  handleDropdownHover() {
    const { dropdown } = this.refs;

    if (dropdown) {
      dropdown.addEventListener("mouseenter", (e) => {
        e.preventDefault();

        if (
          this.element.classList.contains(classes.open) &&
          window.innerWidth >= breakpoints.MD
        ) {
          clearTimeout(this.closeTimeout);
        }

        if (
          !this.element.classList.contains(classes.open) &&
          window.innerWidth >= breakpoints.MD
        ) {
          this.openDropdown();
        }
      });

      dropdown.addEventListener("mouseleave", (e) => {
        e.preventDefault();

        if (
          this.element.classList.contains(classes.open) &&
          window.innerWidth >= breakpoints.MD
        ) {
          this.closeDropdown();
        }
      });
    }
  }

  openDropdown() {
    let root = document.querySelector(":root");
    root.style.setProperty("--header-navigation-min-height", "550px");

    const { dropdownScroll } = this.refs;

    this.element.classList.add(classes.open);
    body.classList.add("header-" + classes.open);

    if (dropdownScroll && window.innerWidth < breakpoints.MD) {
      disableBodyScroll(dropdownScroll);
    }

    dispatchEvent(window, events.HEADER_OPEN);

    this.drawSubNavigation();

    let maxItems = 0;
    const subItems = this.element.querySelectorAll(
      ".header__dropdown-grid-item"
    );
    if (subItems) {
      subItems.forEach(function (item) {
        if (item.classList.contains(classes.open)) {
          maxItems = item.getAttribute("data-max-column-items");
        }
      });
    }
    root.style.setProperty(
      "--header-navigation-min-height",
      maxItems * 42 + "px"
    );

    this.closeSearch();
  }

  handleMobileNavigation(main, listItems, gender) {
    const scope = this;
    let category = null;
    let subCategory = null;

    // Mobile menu navigation
    if (listItems) {
      var children = listItems.childNodes;
      var list = Array.prototype.slice.call(children);

      for (let i = 0; i < list.length; i++) {
        const child = list[i];
        if (
          child &&
          child.classList &&
          child.classList.contains("header__mobile__has-children")
        ) {
          const target =
            scope.refs[scope.camelize(child.getAttribute("data-ref-header"))];
          //target.style.border = "1px blue solid";
          category = child.getAttribute("data-category");
          target.addEventListener("click", (e) => {
            e.preventDefault();

            main.classList.remove("open");
            const target =
              scope.refs[
                scope.camelize(
                  "mobile-" +
                    gender +
                    "-sub-categories-" +
                    e.target.getAttribute("data-category")
                )
              ];
            target.classList.add("open");

            const list =
              scope.refs[
                scope.camelize(
                  "mobile-" +
                    gender +
                    "-sub-categories-" +
                    e.target.getAttribute("data-category") +
                    "-list"
                )
              ];
            var subChildren = list.childNodes;
            var subList = Array.prototype.slice.call(subChildren);
            for (let s = 0; s < subList.length; s++) {
              const subChild = subList[s];
              if (
                subChild &&
                subChild.classList &&
                subChild.classList.contains("header__mobile__has-children")
              ) {
                const subTarget =
                  scope.refs[
                    scope.camelize(subChild.getAttribute("data-ref-header"))
                  ];

                //subTarget.style.border = "1px orange solid";
                subTarget.addEventListener("click", (e) => {
                  const subList =
                    scope.refs[
                      scope.camelize(
                        "mobile-" +
                          gender +
                          "-sub-navigation-" +
                          e.target.getAttribute("data-category") +
                          "-" +
                          e.target.getAttribute("data-sub-category")
                      )
                    ];

                  subList.classList.add("open");
                  const target =
                    scope.refs[
                      scope.camelize(
                        "mobile-" +
                          gender +
                          "-sub-categories-" +
                          e.target.getAttribute("data-category")
                      )
                    ];
                  if (target) {
                    target.classList.remove("open");
                  }
                });

                category = subTarget.getAttribute("data-category");
                subCategory = subTarget.getAttribute("data-sub-category");

                const subBack =
                  scope.refs[
                    scope.camelize(
                      "mobile-" +
                        gender +
                        "-sub-navigation-back-" +
                        category +
                        "-" +
                        subCategory
                    )
                  ];

                if (subBack) {
                  //subBack.style.border = "1px green solid";
                  subBack.addEventListener("click", (e) => {
                    const subTarget =
                      scope.refs[
                        scope.camelize(
                          "mobile-" +
                            gender +
                            "-sub-navigation-" +
                            e.target.getAttribute("data-category") +
                            "-" +
                            e.target.getAttribute("data-sub-category")
                        )
                      ];

                    if (subTarget) {
                      subTarget.classList.remove("open");
                    }
                    const target =
                      scope.refs[
                        scope.camelize(
                          "mobile-" +
                            gender +
                            "-sub-categories-" +
                            e.target.getAttribute("data-category")
                        )
                      ];

                    if (target) {
                      target.classList.add("open");
                    }
                  });
                }
              }
            }
          });

          const back =
            scope.refs[
              scope.camelize(
                "mobile-" + gender + "-sub-categories-back-" + category
              )
            ];
          if (back) {
            back.addEventListener("click", (e) => {
              main.classList.add("open");
              const target =
                scope.refs[
                  scope.camelize(
                    "mobile-" +
                      gender +
                      "-sub-categories-" +
                      e.target.getAttribute("data-category")
                  )
                ];

              if (target) {
                target.classList.remove("open");
              }
            });
          }
        }
      }
    }

    // Mobile menu ctas carousel
    scope.initCarousel(gender);
  }

  initCarousel(gender) {
    let total = 0;
    const container = document.getElementById("mobile-ctas-carousel-" + gender);
    if (container) {
      const camera = container.children[0];
      if (camera) {
        total = camera.children.length;
      }
    }
    if (total > 1) {
      const flicking = new Flicking("#mobile-ctas-carousel-" + gender, {
        align: "center",
        circular: true,
        panelsPerView: 1,
      });
      flicking.on(EVENTS.CHANGED, (evt) => {
        const selected = evt.index;
        const pagination = document.getElementById(
          "pagination-carousel-" + gender
        );
        for (let i = 0; i < pagination.children.length; i++) {
          const child = pagination.children[i];
          child.classList.remove("flicking-pagination-bullet-active");
          if (i === selected) {
            child.classList.add("flicking-pagination-bullet-active");
          }
        }
      });
      flicking.addPlugins(
        new Pagination({
          type: "bullet",
        })
      );
    }
  }

  drawSubNavigation() {
    // Check all lists if the container height is bigger than the container, make it flow in 2 columns.
    const collection = document.getElementsByClassName(
      "header__linklist--dropdown"
    );
    const scope = this;

    for (let i = 0; i < collection.length; i++) {
      const nav = collection[i];
      if (nav) {
        nav.style.height = "auto";
        nav.classList.remove("columns");
        nav.parentNode.parentElement.classList.add("off");
        const containerHeight = nav.parentNode.parentElement.offsetHeight;
        if (containerHeight > 0) {
          if (scope.timer) {
            clearTimeout(scope.timer);
          }
          scope.timer = setTimeout(() => {
            scope.renderSubNavigation(collection, containerHeight);
          }, 250);
        }
      }
    }
    //
  }

  renderSubNavigation(collection, containerHeight) {
    for (let i = 0; i < collection.length; i++) {
      const nav = collection[i];
      if (nav.offsetHeight > containerHeight) {
        const perColumn = Math.floor((containerHeight - 45) / 38);
        const columns = Math.round(nav.children.length / perColumn);
        nav.style.setProperty("--columns", columns);
        nav.classList.add("columns");
        nav.style.height = containerHeight - 30 + "px";
      } else {
        nav.style.height = "auto";
        nav.classList.remove("columns");
      }
      nav.parentNode.parentElement.classList.remove("off");
    }
  }

  closeAllItems() {
    for (let i = 0; i < this.itemsHover.length; i++) {
      this.itemsHover[i].classList.remove("open");
      const id = this.itemsHover[i].getAttribute("data-ref-header");
      const collection = document.getElementsByClassName(id + "-dropdown");
      for (let a = 0; a < collection.length; a++) {
        collection[a].classList.remove("open");
      }
    }
  }

  closeDropdown() {

    const { dropdownScroll } = this.refs;

    this.closeAllItems();

    this.element.classList.remove(classes.open);
    body.classList.remove("header-" + classes.open);

    if (dropdownScroll && window.innerWidth < breakpoints.MD) {
      enableBodyScroll(dropdownScroll);
    }
  }

  handleCollectionLinkHover() {
    const collectionImageLinks = Array.from(
      this.element.querySelectorAll("[data-collection-image-link]")
    );

    collectionImageLinks.forEach((collectionImageLink) => {
      collectionImageLink.addEventListener("mouseover", () => {
        const collectionHandle = collectionImageLink.dataset.collectionHandle;
        this.updateCollectionImage(collectionHandle);
      });

      collectionImageLink.addEventListener("mouseout", () => {
        this.updateCollectionImage("default");
      });
    });
  }

  updateCollectionImage(collectionHandle) {
    const { collectionImages } = this.refs;

    if (collectionImages) {
      const collectionImagesArray = Array.from(
        collectionImages.querySelectorAll(selectors.collectionImage)
      );

      for (let i = 0; i < collectionImagesArray.length; i++) {
        if (
          collectionImagesArray[i].dataset.collectionHandle === collectionHandle
        ) {
          collectionImagesArray[i].classList.remove(classes.hidden);
        } else {
          collectionImagesArray[i].classList.add(classes.hidden);
        }
      }
    }
  }

  bindWindowResizeHandler() {
    this.resizeHandler = debounce(() => {
      this.handleResize();
    }, 250);

    window.addEventListener("resize", this.resizeHandler);
  }

  handleResize() {
    const { dropdownScroll } = this.refs;
    if (
      dropdownScroll &&
      this.element.classList.contains(classes.open) &&
      window.innerWidth < breakpoints.MD
    ) {
      disableBodyScroll(dropdownScroll);
    } else {
      this.element.classList.remove(classes.open);
      enableBodyScroll(dropdownScroll);
    }
  }

  bindBodyStyleListener() {
    const config = {
      attributes: true,
      attributeFilter: ["style"],
    };

    this.mutationObserver = new MutationObserver((e) => {
      this.handleBodyMutation(e);
    });

    this.mutationObserver.observe(body, config);
  }

  handleBodyMutation(e) {
    this.element.style.paddingRight = body.style.paddingRight;
  }

  forceDownloadCollectionImages() {
    const { collectionImages } = this.refs;

    if (collectionImages && window.innerWidth >= breakpoints.MD) {
      const collectionImagesArray = Array.from(
        collectionImages.querySelectorAll(
          selectors.collectionImage + " img.lazy"
        )
      );

      dispatchEvent(window, events.LOAD_IMAGES, {
        images: collectionImagesArray,
      });
    }
  }

  handleChangeCurrency() {
    const languageLinks = this.element.querySelectorAll(
      ".header__language-link"
    );
    if (languageLinks) {
      languageLinks.forEach(function (languageLink) {
        languageLink.href = window.location
          .toString()
          .replace(window.location.origin, languageLink.dataset.href);
      });
    }
  }

  cleanup() {
    const { dropdownScroll } = this.refs;
    if (dropdownScroll) {
      enableBodyScroll(dropdownScroll);
    }
    if (this.logosTimer) clearInterval(this.logosTimer);
    window.removeEventListener("resize", this.resizeHandler);
    window.removeEventListener("click", this.windowClickListener);
    window.removeEventListener("scroll", this.scrollHandler);
    this.mutationObserver.disconnect();

    if(this.searchInput && this.searchChangeHandler) {
      this.searchInput.removeEventListener("change",this.searchChangeHandler);
      this.searchChangeHandler = null;
    }
  }
}
